import { unix } from 'moment'

export default class DirectIntroduction {
  constructor(object) {
    this.candidateName = object.candidate_name
    this.cooperatedAt = unix(object.cooperated_at)
    this.culture = object.culture
    this.id = object.id
    this.memo = object.memo
    this.motivationToChangeJob = object.motivation_to_change_job || null
    this.reason = object.reason
    this.skill = object.skill
  }

  get isCultureExist() {
    return this.culture !== null && typeof this.culture !== typeof undefined
  }

  get isSkillExist() {
    return this.skill !== null && typeof this.skill !== typeof undefined
  }
}
